const convertStrToPrice = (origin: string): string => {
    let originPrice = Number(origin);
    if (isNaN(originPrice)) return "-";
    let result = Math.round(originPrice).toLocaleString("ko-KR");
    return result;
};
export default convertStrToPrice;
